import { DisplayContent } from 'react-content-engine'

export default DisplayContent
